var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "#ED3241"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4999_11015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 10,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80806 8.80806C9.05214 8.56398 9.44786 8.56398 9.69194 8.80806L17.1919 16.3081C17.436 16.5521 17.436 16.9479 17.1919 17.1919C16.9479 17.436 16.5521 17.436 16.3081 17.1919L8.80806 9.69194C8.56398 9.44786 8.56398 9.05214 8.80806 8.80806Z",
    fill: "#006FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1919 8.80806C16.9479 8.56398 16.5521 8.56398 16.3081 8.80806L8.80806 16.3081C8.56398 16.5521 8.56398 16.9479 8.80806 17.1919C9.05214 17.436 9.44786 17.436 9.69194 17.1919L17.1919 9.69194C17.436 9.44786 17.436 9.05214 17.1919 8.80806Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4999_11015)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 10,
    height: 10,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancel);
export default __webpack_public_path__ + "static/media/ic_cancel.4eebd53a9b8eed6867b0521b3bf7fa00.svg";
export { ForwardRef as ReactComponent };